import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageService } from 'src/core/message-service/message-service.service';
import { RequestValidateOtp, ResponseValidateOtp } from 'src/core/message-service/message-service.types';

@Component({
  selector: 'app-confirm-otp-email',
  templateUrl: './confirm-otp-email.component.html',
  styleUrls: ['./confirm-otp-email.component.css']
})
export class ConfirmOtpEmailComponent implements OnInit {
  @ViewChild('otpSignUp') signInNgForm: NgForm;
  otpSignUpForm: UntypedFormGroup;
  clickConfirm = false;
  constructor(
    public dialogRef: MatDialogRef<ConfirmOtpEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private _formBuilder: UntypedFormBuilder,
    private _messageService: MessageService,
  ) {

  }
  ngOnInit(): void {
    this.otpSignUpForm = this._formBuilder.group({
      otp: [null, [Validators.required]],
    });
  }

  onNoClick(): void {
    this.clickConfirm = true;
    if (this.data.actualizacion) {
      this.validarOptActualizacionDatosPersonales();
    } else {
      this.valedateOtp()
    }

  }
  validarOptActualizacionDatosPersonales() {
    
    console.log('REALZIAR VALIDACION DE opt por aca',this.otpSignUpForm.get('otp').value)
    return this.dialogRef.close(this.otpSignUpForm.get('otp').value);
    //this.dialogRef.close(false);
  }

  valedateOtp() {
    if (this.otpSignUpForm.invalid) {
      return;
    }
    const request = {
      correo: this.data.correo,
      numero: this.data.telefono,
      otp: this.otpSignUpForm.get('otp').value,
    } as RequestValidateOtp;
    this._messageService.ValidateOtp(request).subscribe({
      next: (response: ResponseValidateOtp) => {
        this.dialogRef.close(true);
      },
      error: (error: any) => {
        this.dialogRef.close(false);
        console.log('>>> error  : ', error);
      }
    });
  }
}
